export const ADD_RECIPIENT_FORM = {
  account_type: '',
  bank_account_country_code: '',
  currency_code: '',
  remitter_beneficiary_relationship: '',
  full_name: '',
  routing_code: '',
  secondary_routing_code: '',
  bank_name: '',
  bank_account_number: '',
  country_code: '', //Bene Address country
  building_name: '',
  building_number: '',
  street: '',
  street_name: '',
  street_type: '',
  unit_number: '',
  floor_number: '',
  address1: '',
  address2: '',
  street_number: '',
  city: '',
  district: '',
  state: '',
  town: '',
  suburb: '',
  province: '',
  block_number: '',
  postcode: ''
};
